module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-row', {
    staticStyle: {
      "padding-bottom": "10px"
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.search($event)
      }
    }
  }, [_c('el-col', {
    staticClass: "search-box",
    attrs: {
      "span": 24
    }
  }, [_c('span', [_c('label', [_vm._v("编号：")]), _vm._v(" "), _c('el-input', {
    staticClass: "search-input",
    attrs: {
      "placeholder": "请输入编号"
    },
    model: {
      value: (_vm.query.id),
      callback: function($$v) {
        _vm.$set(_vm.query, "id", $$v)
      },
      expression: "query.id"
    }
  })], 1), _vm._v(" "), _c('span', [_c('label', [_vm._v("名称：")]), _vm._v(" "), _c('el-input', {
    staticClass: "search-input",
    attrs: {
      "placeholder": "请输入名称"
    },
    model: {
      value: (_vm.query.name),
      callback: function($$v) {
        _vm.$set(_vm.query, "name", $$v)
      },
      expression: "query.name"
    }
  })], 1), _vm._v(" "), _c('span', [_c('label', [_vm._v("手机：")]), _vm._v(" "), _c('el-input', {
    staticClass: "search-input",
    attrs: {
      "placeholder": "请输入手机"
    },
    model: {
      value: (_vm.query.phone),
      callback: function($$v) {
        _vm.$set(_vm.query, "phone", $$v)
      },
      expression: "query.phone"
    }
  })], 1), _vm._v(" "), _c('span', [_c('label', [_vm._v("状态：")]), _vm._v(" "), _c('el-select', {
    attrs: {
      "placeholder": "请选择",
      "clearable": true
    },
    model: {
      value: (_vm.query.status),
      callback: function($$v) {
        _vm.$set(_vm.query, "status", $$v)
      },
      expression: "query.status"
    }
  }, _vm._l((_vm.statusList), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.text,
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('span', [_c('label', [_vm._v("推荐门店:")]), _vm._v(" "), _c('DropdownSelect', {
    attrs: {
      "action": _vm.api.dealer.shop.all,
      "textField": "name",
      "valueField": "id"
    },
    model: {
      value: (_vm.query.recShopId),
      callback: function($$v) {
        _vm.$set(_vm.query, "recShopId", $$v)
      },
      expression: "query.recShopId"
    }
  })], 1), _vm._v(" "), _c('span', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.search
    }
  }, [_vm._v("搜索")])], 1)])], 1), _vm._v(" "), _c('page-table', {
    attrs: {
      "data-api": this.api.dealer.shop,
      "viewable": false,
      "keyField": "id"
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "id",
      "label": "编号",
      "width": "50"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "名称"
    }
  }), _vm._v(" "), (!_vm.isMobile()) ? _c('el-table-column', {
    attrs: {
      "prop": "phone",
      "label": "手机"
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.isMobile()) ? _c('el-table-column', {
    attrs: {
      "prop": "recShopName",
      "label": "推荐门店"
    }
  }) : _vm._e(), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "50",
      "prop": "status",
      "label": "状态",
      "formatter": _vm.statusFormatter
    }
  }), _vm._v(" "), (!_vm.isMobile()) ? _c('el-table-column', {
    attrs: {
      "prop": "created",
      "label": "添加时间",
      "formatter": _vm.dateFormatter
    }
  }) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3fe86118","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/dealer/shop/List.vue
// module id = 1137
// module chunks = 2